import { css } from 'styled-components';

export const abTheme = css`
    --color-primary: rgb(34, 34, 34);

    --color-state-primary: rgba(34, 34, 34, 0.07);
    --color-state-secondary: rgba(34, 34, 34, 0.24);
    --color-state-tertiary: rgba(48, 49, 48, 0.07);

    --color-outline: #0078BD;

    /* Home Page */
    --home-hero-background: linear-gradient(239deg, #DD2A30 0%, #F23E44 100%);
    --home-hero-title-color: white;
    --home-hero-subtitle-color: white;

    /* Subscription Page */
    --subscription-hero-background: #F7F7FA;
    --subscription-hero-title-color: black;
    --subscription-hero-subtitle-color: black;

    /* User Shortcuts */
    --color-outline-accent: #DD2A30;
`;
